import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const PickerViewColumn = ({ children }) => _jsx(_Fragment, { children: children });
export default PickerViewColumn;
